// extracted by mini-css-extract-plugin
module.exports = {"contest__banner":"HomeCustomBanner_contest__banner__8Citu","contest__banner__close":"HomeCustomBanner_contest__banner__close__tXUh9"};